import React, { Component } from 'react';
import './RichEdit.css';

const allowedKeyCodes = [8, 37, 38, 39, 40];
const allowedKeyCodesWithCtrlKey = [65, 90, 86, 67, 88];
const defaultParagraphSeparator = 'div';
const defaultParagraphSeparatorString = 'defaultParagraphSeparator';
const formatBlock = 'formatBlock';
const exec = (command, value = null) => document.execCommand(command, false, value);

// 参考: https://github.com/jaredreich/pell
// 参考: https://github.com/bpetetot/react-pell
class RichEdit extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this._resetView();
    }

    shouldComponentUpdate(nextProps, nextState) {
        return false;
    }

    _onChange = () => {
        // TODO
    };

    _onContentLength = () => {
        if (this.props.onContentLength) {
            this.props.onContentLength(this.getContentLength());
        }
    };

    _onInput = (e) => {
        if (this._view) {
            if (this._view.content.innerHTML === '<br>') {
                this._view.content.innerHTML = '';
            }
            this._onContentLength();
        }
    };

    _onKeyDown = (e) => {
        if (!this.props.maxLength) {
            return;
        }

        const isAllowedKey = allowedKeyCodes.includes(e.keyCode);
        const isShortcut = e.ctrlKey && allowedKeyCodesWithCtrlKey.includes(e.keyCode);
        const isAllowedAction = isAllowedKey || isShortcut;
        if (isAllowedAction) {
            return;
        }

        if (this.props.maxLength) {
            const allowedPasteLength = this._allowedTextLength();
            if (!allowedPasteLength) {
                e.preventDefault();
            }
        }
    };

    _onCompositionEnd = (e) => {
        if (this.props.maxLength) {
            // https://juejin.cn/post/7133579641382436878
            const diff = e.target.innerText.length - this.props.maxLength;
            if (diff > 0) {
                const range = document.createRange();
                const sel = window.getSelection();
                const offset = sel.anchorOffset;
                const node = sel.anchorNode;
                const text = node.textContent;
                range.selectNodeContents(node);
                sel.removeAllRanges();
                sel.addRange(range);
                sel.extend(node, offset);
                document.execCommand('delete', false);
                document.execCommand('insertText', false, text.substring(0, offset - diff));
            }
        }
    };

    _onPaste = (e) => {
        e.preventDefault();
        const items = e.clipboardData.items;
        for (let i = 0; i < items.length; ++i) {
            const item = items[i];
            if (item.kind === 'string' && item.type === 'text/plain') {
                item.getAsString((s) => {
                    this._insertText(s);
                });
            } else if (item.kind === 'file' && item.type.startsWith('image/')) {
                if (this.props.canPasteImage && this._canInsertImage()) {
                    const blob = item.getAsFile();
                    const url = URL.createObjectURL(blob);
                    this._insertImage(url);
                }
            }
        }
    };

    _resetView = () => {
        if (this._view) {
            this._view.content.removeEventListener('input', this._onInput);
            this._view.content.removeEventListener('keydown', this._onKeyDown);
            this._view.content.removeEventListener('paste', this._onPaste);
            this._view.content.removeEventListener('compositionend', this._onCompositionEnd);
            delete this._view;
        }
    };

    _setupRef = (r) => {
        this._resetView();
        this._view = r;
        if (this._view) {
            const content = document.createElement('div')
            this._view.content = content;
            content.contentEditable = true;
            content.className = 'pell_rich_edit_content';
            /*
            content.oninput = ({ target: { firstChild } }) => {
                if (firstChild && firstChild.nodeType === 3) exec(formatBlock, `<${defaultParagraphSeparator}>`)
                else if (content.innerHTML === '<br>') content.innerHTML = ''
                settings.onChange(content.innerHTML)
            }
            content.onkeydown = event => {
                if (event.key === 'Enter' && queryCommandValue(formatBlock) === 'blockquote') {
                    setTimeout(() => exec(formatBlock, `<${defaultParagraphSeparator}>`), 0)
                }
            }
            */
            this._view.appendChild(content);

            const styleWithCSS = true;
            if (styleWithCSS) {
                exec('styleWithCSS');
            }
            exec(defaultParagraphSeparatorString, defaultParagraphSeparator);

            if (this._initHtml) {
                this._view.content.innerHTML = this._initHtml;
                delete this._initHtml;

                this._onContentLength();
            }

            this._view.content.addEventListener('input', this._onInput);
            this._view.content.addEventListener('keydown', this._onKeyDown);
            this._view.content.addEventListener('paste', this._onPaste);
            this._view.content.addEventListener('compositionend', this._onCompositionEnd);
        }
    };

    setHtml(html) {
        if (this._view) {
            this._view.content.innerHTML = this._initHtml;
            this._onContentLength();
        } else {
            this._initHtml = html;
        }
    }

    getHtml() {
        if (this._view) {
            return this._view.content.innerHTML;
        }
        return '';
    }

    getContentLength() {
        if (this._view) {
            const images = this._view.content.getElementsByTagName('img');
            const text = this._view.content.innerText;
            return {all: text.length + images.length, trim: text.trim().length + images.length};
        }
        return {all: 0, trim: 0};
    }

    getRemainImageCount() {
        if (!this._view) {
            return 0;
        }

        const images = this._view.content.getElementsByTagName('img');
        let total = images.length;
        let sel = 0;
        const range = this.getSelectedRange();
        if (range) {
            for (let i = 0; i < images.length; ++i) {
                if (range.intersectsNode(images[i])) {
                    sel += 1;
                }
            }
        }
        return total - sel;
    }

    getSelectedRange() {
        if (!this._view) {
            return null;
        }

        const selection = window.getSelection();
        if (!selection) {
            return null;
        }

        if (selection.rangeCount < 1) {
            return null;
        }

        const range = selection.getRangeAt(0);
        if (!range) {
            return null;
        }

        const start = range.startContainer;
        const end = range.endContainer;
        if (this._view.contains(start) && this._view.contains(end)) {
            return range;
        }
        return null;
    }

    _selectedText() {
        const range = this.getSelectedRange();
        if (range) {
            const selection = window.getSelection();
            return selection.toString();
        }
        return "";
    }

    _allowedTextLength() {
        if (!this._view) {
            return 0;
        }

        if (!this.props.maxLength) {
            return -1;
        }

        const content = this._view.content.innerText
        const contentLength = content.length
        const selectedText = this._selectedText();
        const allowlen = this.props.maxLength - contentLength + selectedText.length;
        if (allowlen >= 0) {
            return allowlen;
        }
        return 0;
    }

    _insertText(s) {
        if (!this._view) {
            return;
        }

        if (this.props.maxLength) {
            const allowedPasteLength = this._allowedTextLength();
            if (allowedPasteLength > 0) {
                s = s.substring(0, allowedPasteLength);
            } else {
                s = '';
            }
        }

        if (s) {
            document.execCommand("insertText", false, s);
        }
    }

    insertImage(source) {
        if (this._canInsertImage()) {
            const url = source.uri;
            this._insertImage(url);
        }
    }

    blur() {
        //设置它失去光标
        if (this._view) {
            this._view.content.blur();
        }
    }

    focus() {
        //设置得到光标
        if (this._view) {
            this._view.content.focus();
        }
    }

    _canInsertImage() {
        if (this.props.maxImage && (this.props.maxImage > 0) &&
            (this.getRemainImageCount() >= this.props.maxImage))
        {
            return false;
        }
        return true;
    }

    _insertImage(url) {
        if (this._view) {
            let range = this.getSelectedRange();
            if (!range) {
                range = new Range();
                let lastItem = this._view.content.lastElementChild;
                if (lastItem) {
                    range.setStartAfter(lastItem);
                    range.setEndAfter(lastItem);
                } else {
                    range.selectNodeContents(this._view.content);
                    range.collapse(false);
                }
                const selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
            }

            //document.execCommand("insertImage", false, url);
            if (this.props.imageHeight) {
                document.execCommand("insertHTML", false, `<img style='height:${this.props.imageHeight}px' src='${url}'/>`);
            } else {
                document.execCommand("insertHTML", false, `<img src='${url}'/>`);
            }

            this.blur();
        }
        /* NOTE: 直接操作DOM会没有undo/redo
        const imgNode = document.createElement('img');
        imgNode.src = url;

        const range = this.getSelectedRange();
        if (range) {
            const selection = window.getSelection();
            range.deleteContents();
            range.insertNode(imgNode);
            range.setStartAfter(imgNode);
            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
        } else {
            this._view.content.appendChild(imgNode);
        }
        */
    }

    render() {
        const { ...props } = this.props;
        return (<div className='pell_rich_edit' ref={this._setupRef} {...props}/>);
    }
};

RichEdit.defaultProps = {
    maxImage: undefined,
    maxLength: undefined,
    imageHeight: undefined,
    canPasteImage: undefined,
    onContentLength: undefined,
};

export default RichEdit;
